var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { getUntilEnd, getUntilMin } from './common';
import { toUTCDate } from '../../utils';
import { ZonedDate } from '@progress/kendo-date-math';
var RADIO_ATTRIBUTES = {
    type: 'radio',
    name: 'end',
    className: 'k-radio'
};
/** @hidden */
export var RecurrenceEndEditor = function (props) {
    var titleClassName = props.titleClassName, editorClassName = props.editorClassName, title = props.title, endRule = props.endRule, endNever = props.endNever, endAfter = props.endAfter, endOn = props.endOn, onEndRuleChange = props.onEndRuleChange, start = props.start, endOccurrence = props.endOccurrence, onUntilChange = props.onUntilChange, onCountChange = props.onCountChange, timezone = props.timezone;
    var count = props.count || 1;
    var until = getUntilEnd(start, props.until);
    var untilMin = getUntilMin(start, props.until);
    var onChangeHandler = React.useCallback(function (e) {
        onEndRuleChange({
            value: e.target.value,
            count: count,
            until: until
        });
    }, [onEndRuleChange]);
    var onUntilChangeHandler = React.useCallback(function (event) {
        // Read the until date as UTC date parts to avoid interfering with the local time zone.
        var newUntil = toUTCDate(event.target.value);
        newUntil.setUTCDate(newUntil.getUTCDate() + 1);
        // Convert to the scheduler time zone.
        onUntilChange(ZonedDate.fromUTCDate(newUntil, timezone).toLocalDate());
    }, [onUntilChange]);
    var onCountChangeHandler = React.useCallback(function (event) {
        onCountChange(event.target.value);
    }, [onCountChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: titleClassName }, title),
        React.createElement("div", { className: editorClassName },
            React.createElement("ul", { className: "k-reset" },
                React.createElement("li", null,
                    React.createElement("input", __assign({}, RADIO_ATTRIBUTES, { checked: endRule === 'never', id: 'k-endrule-never', onChange: onChangeHandler, value: 'never' })),
                    React.createElement("label", { className: 'k-radio-label', htmlFor: 'k-endrule-never' }, endNever)),
                React.createElement("li", null,
                    React.createElement("input", __assign({}, RADIO_ATTRIBUTES, { checked: endRule === 'count', id: 'k-endrule-count', onChange: onChangeHandler, value: 'count' })),
                    React.createElement("label", { className: 'k-radio-label', htmlFor: 'k-endrule-count' }, endAfter),
                    "\u00A0",
                    React.createElement(NumericTextBox, { width: 70, disabled: endRule !== 'count', min: 1, value: count, onChange: onCountChangeHandler }),
                    "\u00A0",
                    React.createElement("span", null, endOccurrence)),
                React.createElement("li", null,
                    React.createElement("input", __assign({}, RADIO_ATTRIBUTES, { checked: endRule === 'until', id: 'k-endrule-until', onChange: onChangeHandler, value: 'until' })),
                    React.createElement("label", { className: 'k-radio-label', htmlFor: 'k-endrule-until' }, endOn),
                    "\u00A0",
                    React.createElement(DatePicker, { width: 150, disabled: endRule !== 'until', min: untilMin, value: until, onChange: onUntilChangeHandler }))))));
};
//# sourceMappingURL=RecurrenceEndEditor.js.map